import BasicAutoQueryController from "servicestack/auto-query/auto-query.controller";
import salesrepConfig from 'emun.salesrep/salesrep.config'

export const colors = {
  ["All"]: "#d4dcf0",
  ["HFC"]: "#f4ebbf",
  ["HU"]: "#e69789",
  ["BYDomestic"]: "#bcf3a9",
  ["SMDomestic"]: "#d5dad2"
};

export default class CustomerTotalsVendorController extends BasicAutoQueryController {
  constructor() {
    super();
    const $ctrl = this;
    console.info("#ctrl", $ctrl);
    $ctrl.colors = colors;
    $ctrl.ngModel = this;
  }

  getQuery() {
    const $ctrl = this;
    const entityType =
      $ctrl.context === "manager"
        ? "ManagerId"
        : $ctrl.context === "customer"
        ? "CustomerId"
        : $ctrl.context === "rep"
        ? "SalesRepId"
        : "EntityId";
    return {
      url: "QuerySalesDailyCustomerVendorTotals.json",
      criteria: {
        [entityType]: $ctrl.entity.id,
        Sum: "YTD,YTDQTY,LYTD,LYTDQTY,LastYear,LYQTY,YBL,YBLQTY,BACKLOG",
        Max: "LastOrderDate",
        GroupBy: "VendorName"
      },
      autoLoad: true,
      pageSize: 10,
      onLoaded: $ctrl.onLoaded.bind($ctrl)
    };
  }

  onLoaded(args) {
    args.results.forEach(r => {
      r.color = colors[r.vendorName];
      var percent = Math.round((r.sumYTD / r.sumLYTD) * 100);
		if (percent < 100) {
			r.increase = 100 - percent;
			r.trend = 'down';
		} else if (percent > 100) {
			r.increase = percent - 100;
			r.trend = 'up';
		} else {
			r.increase = 100;
			r.trend = 'neutral';
		}
    });
  }
}
